import Vue from 'vue'

const luAgency = {
  state: {
    luAgencies: [],
    selectedLuAgency: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luAgencies(state) {
      return state.luAgencies
    },
    selectedLuAgency(state) {
      return state.selectedLuAgency
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luAgencies(state, payload) {
      state.luAgencies = payload
    },
    selectedLuAgency(state, payload) {
      state.selectedLuAgency = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuAgency(context, payload) {
      context.commit('selectedLuAgency', payload)
    },
    loadLuAgencies(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuAgency'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('luAgencies', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedLuAgency(context, payload) {
      if (context.state.selectedLuAgency && context.state.selectedLuAgency.ID) {
        context.dispatch(
          'loadSelectedLuAgency',
          context.state.selectedLuAgency.ID
        )
      }
    },
    loadSelectedLuAgency(context, payload) {
      if (
        context.state.selectedLuAgency &&
        context.state.selectedLuAgency.ID != payload
      ) {
        context.commit('selectedLuAgency', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuAgency/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLuAgency', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadLuAgencies(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadLuAgencies')
      })
    },
    updateLuAgency(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuAgency/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'agency updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuAgencies')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createLuAgency(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuAgency`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'agency created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuAgencies')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveLuAgency(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuAgency', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLuAgency', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLuAgency(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuAgency/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'agency deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuAgencies')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default luAgency
